module.exports = __webpack_public_path__ + "img/logo_pay_color.57d95872.png";